<template>
    <div class="project-cover project_cover_reveal">
        <img src="../../../assets/img/projects/todo-graphql.png" />
    </div>
    <div class="about">
        <h1 class="title project_title_reveal">Todo GraphQL API</h1>
        <p class="text project_text_languages_reveal">
            API de pendências onde elas estão disponibilizadas apenas para seus próprios usuários, contando também com
            um sistema de autenticação JWT para garantir a segurança dos dados. (Projeto Pessoal)
        </p>
        <ul class="languages project_text_languages_reveal">
            <li class="language-box">
                <img src="../../../assets/img/languages/nodejs.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/ts.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/graphql.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/mongodb.svg" class="language" />
            </li>
        </ul>
        <a
            href="https://github.com/eubrunocoelho/todo-graphql"
            class="show-more project_link_reveal"
            target="_blank"
            rel="noopener noreferrer"
        >
            Exibir mais
        </a>
    </div>
</template>

<script>
export default {
    name: 'ProjectTodoGraphQLAPI',
};
</script>
